/* assets/mm-fact-grid.js — <mm-fact-grid>: Punkt-Indikator für die Mobile-Swipe-Karten */
(function () {
  'use strict';
  if (!('customElements' in window) || customElements.get('mm-fact-grid')) return;
  class MMFactGrid extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-mm-facts]'); this.dots = Array.from(this.querySelectorAll('[data-mm-dot]'));
      if (!this.track || !this.dots.length) return;
      this._onScroll = this._onScroll.bind(this); this._onDot = this._onDot.bind(this);
      this.track.addEventListener('scroll', this._onScroll, { passive: true }); this.addEventListener('click', this._onDot);
    }
    disconnectedCallback() { if (this.track) this.track.removeEventListener('scroll', this._onScroll); this.removeEventListener('click', this._onDot); }
    _onScroll() {
      if (this._raf) return;
      this._raf = requestAnimationFrame(() => { this._raf = null; var w = this.track.clientWidth || 1; this._setActive(Math.round(this.track.scrollLeft / w)); });
    }
    _onDot(evt) {
      var dot = evt.target.closest('[data-mm-dot]'); if (!dot) return;
      var i = parseInt(dot.dataset.mmDot, 10); var tile = this.track.children[i]; if (!tile) return;
      this.track.scrollTo({ left: tile.offsetLeft - this.track.offsetLeft, behavior: 'smooth' }); this._setActive(i);
    }
    _setActive(i) {
      this.dots.forEach((d, k) => { var on = k === i; d.classList.toggle('is-active', on); if (on) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
    }
  }
  customElements.define('mm-fact-grid', MMFactGrid);
})();
